module.exports = __webpack_public_path__ + "static/media/why_choose_rgcpl_img.7c152394.jpeg";